/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface Category
 */
export interface Category {
  /**
   *
   * @type {number}
   * @memberof Category
   */
  readonly id: number
  /**
   *
   * @type {string}
   * @memberof Category
   */
  name?: string
  /**
   *
   * @type {string}
   * @memberof Category
   */
  slug?: string | null
}

/**
 * Check if a given object implements the Category interface.
 */
export function instanceOfCategory(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value

  return isInstance
}

export function CategoryFromJSON(json: any): Category {
  return CategoryFromJSONTyped(json, false)
}

export function CategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): Category {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    name: !exists(json, 'name') ? undefined : json['name'],
    slug: !exists(json, 'slug') ? undefined : json['slug'],
  }
}

export function CategoryToJSON(value?: Category | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    name: value.name,
    slug: value.slug,
  }
}
